import styled from 'styled-components';
import { getRelativeHeight } from '../../components/CardReader/CardReader';
import CardReaderButton from '../../components/CardReaderButton';

const ZoneButton = styled(CardReaderButton)`
  display: block;
  width: 100%;
  height: ${getRelativeHeight(58, (props) => props.zoomLevel)};
`;

export default ZoneButton;
